var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityData, field, identifier } from "..";
export class NotificationData extends EntityData {
}
__decorate([
    identifier,
    __metadata("design:type", String)
], NotificationData.prototype, "identifier", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "userId", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "username", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "messageKey", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "messageParams", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "actionLabelKey", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "type", void 0);
__decorate([
    field,
    __metadata("design:type", String)
], NotificationData.prototype, "data", void 0);
__decorate([
    field,
    __metadata("design:type", Boolean)
], NotificationData.prototype, "viewed", void 0);
//# sourceMappingURL=notification.data.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/notification/notification.data.js
// module id = null
// module chunks = 